import React from 'react';
import {NodeProps} from 'reactflow';

import BenchlingNode from '../BenchlingNode/BenchlingNode';
import {
  BenchlingNodeCustomization,
  BenchlingNodeData,
  BenchlingNodeHeaderProps,
} from '../BenchlingNode/BenchlingNodeTypes';

interface NoRows {}

/**
 * A wrapper around BenchlingNode that always renders with no sections (header-only node).
 * All props for the node header are accepted.
 *
 * @example
 * function MyComponent() {
 *   const nodeData = {
 *     nodeName: 'Header Node',
 *     nodeIcon: 'folder',
 *     // ...other BenchlingNodeHeaderProps
 *   };
 *   return <BenchlingTitleNode data={nodeData} />;
 * }
 */
export default function BenchlingTitleNode(
  props: NodeProps<
    BenchlingNodeHeaderProps & Pick<BenchlingNodeCustomization<NoRows>, 'nodeHeaderHandleRenderer'>
  >
): JSX.Element {
  const {data, ...rest} = props;
  const benchlingNodeData: BenchlingNodeData<NoRows> = {
    ...data,
    sections: [],
    hideSectionSummaries: true,
    rowRenderer: () => null,
  } as BenchlingNodeData<NoRows>;
  return <BenchlingNode {...rest} data={benchlingNodeData} />;
}
